import React from "react";
import Tooltip from "@amzn/meridian/tooltip";
import Loader from "@amzn/meridian/loader"

export const ConditionalPlaceholder = ({placeholder, args, view}) => {
    return placeholder ? loaderTooltipPlaceholder(args) : view;
}

export const loaderTooltipPlaceholder = ({tooltipTitle, tooltipPosition, loaderSize}) => {
    return (
        <Tooltip title={tooltipTitle} position={tooltipPosition}>
            <Loader size={loaderSize}/>
        </Tooltip>
    )
}


// WEBPACK FOOTER //
// ./src/components/util/ConditionalPlaceholder.js